import React from 'react'

import { Table, TableRow, TableCol } from '../../../../../components/pdf/Table'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { useReplies } from '../../_load/ServiceOrderLoader'
import { findReplyByQuestionId, getReplyValue } from '../../_helpers/pdfHelpers'

const Footer = () => {
  const replies = useReplies()

  const deliveryTime = getReplyValue(findReplyByQuestionId(replies, 279))
  const loc = getReplyValue(findReplyByQuestionId(replies, 280))

  return (
    <>
      <Table width="100%" useFontBaseColor fixedLayout>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold size="h5" align="center">
              PAYMENT REMITTANCE INFORMATION
            </Text>
          </TableCol>
        </TableRow>
      </Table>
      <Separator weight={10} />
      <Table width="100%" useFontBaseColor fixedLayout>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold></Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold></Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center">
              Delivery time
            </Text>
            <Text semibold align="center">
              Shipping date
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center">
              Letter of Credit
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold></Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold></Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text>{deliveryTime}</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text>{loc}</Text>
          </TableCol>
        </TableRow>
      </Table>
    </>
  )
}

export default Footer
